import UserService from '@/services/user.service';
const state = {
    technicians: [],
    loading: false
};
/* eslint-disable no-shadow */
const mutations = {
    addTechnician: (state, tech) => {
        if (state.technicians.some(v => v.id === tech.id)) {
            return;
        }
        state.technicians.push(tech);
    },

    updateTechnician: (state, tech) => {
        for (let v of state.technicians) {
            if (v.id === tech.id) {
                v = Object.assign(v, tech);
                break;
            }
        }
    },

    getTechnicians: (state, technicians) => {
        state.technicians = technicians;
    },

    setLoading: (state, loading) => {
        state.loading = loading;
    }
};

const actions = {
    addTechnician({ commit }, tech) {
        commit('addTechnician', tech);
    },
    updateTechnician({ commit }, tech) {
        commit('updateTechnician', tech);
    },
    getTechnicians({ commit }) {
        commit('setLoading', true);
        UserService.getTechnicians().then(
            response => {
                commit('getTechnicians', response.data);
                commit('setLoading', false);
            },
            error => {
                console.log(error.response && error.response.data ||
                    error.message || error.toString());
            }
        );
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
/* eslint-enable no-shadow */
